var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKatalonRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 27.5,
    fill: "#fff",
    stroke: "#DBDDE5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#z1lexq0saa)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3yupdwgn2b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36 32h-8v8h8v-8z",
    fill: "#19D89F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.999 16 20 24.001V32h7.999L36 24.001V16h-8.001z",
    fill: "#000"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "z1lexq0saa"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(12 12)",
    d: "M0 0h32v32H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "3yupdwgn2b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(20 16)",
    d: "M0 0h16v24H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKatalonRounded);
export default __webpack_public_path__ + "static/media/katalon-rounded.329d06ee088a7dedc9bdc58a6a4d87e3.svg";
export { ForwardRef as ReactComponent };